module.exports = __webpack_public_path__ + "img/coffee-beans.0da41d6e.svg";